<lcs-loading-overlay class="flex-dir-col" [show]="callState | lcsCallState : 'loading'">
  <div>
    <div class="compact-register-header flex-container space-between">
      <div class="ml-auto">
        @if (canEdit) {
          <button
            class="create-btn"
            type="button"
            mat-raised-button
            color="primary"
            (click)="onAddScheduleHourClick()"
            >Add Schedule Hour</button
            >
          }
        </div>
      </div>
      <lcs-responsive-table [columns]="columns">
        <table lcs-table [dataSource]="scheduleHourItems">
          <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
          <tr lcs-row *lcsResponsiveRowDef="let index = dataIndex" [hidden]="scheduleHourItems[index].isDeleted"></tr>
          <ng-container lcsColumnDef="DayOfWeek" width="6">
            <th lcs-header-cell *lcsHeaderCellDef id="open-hours-column-header">Day of Week</th>
            <td lcs-cell *lcsCellDef="let index = dataIndex">
              <a>
                {{ scheduleHourItems[index].dayOfWeek }}
              </a>
            </td>
          </ng-container>
          <ng-container lcsColumnDef="OpenTime" width="6">
            <th lcs-header-cell *lcsHeaderCellDef id="open-hours-column-header">Open Time</th>
            <td lcs-cell *lcsCellDef="let index = dataIndex">
              <a>
                {{ scheduleHourItems[index].openTime | date : 'hh:mm aa&nbsp;&nbsp;' : 'UTC' }}
              </a>
            </td>
          </ng-container>
          <ng-container lcsColumnDef="CloseTime" width="6">
            <th lcs-header-cell *lcsHeaderCellDef id="open-hours-column-header">Close Time</th>
            <td lcs-cell *lcsCellDef="let index = dataIndex">
              <a>
                {{ scheduleHourItems[index].closeTime | date : 'hh:mm aa&nbsp;&nbsp;' : 'UTC' }}
              </a>
            </td>
          </ng-container>
          <ng-container lcsColumnDef="MoreActions" width="2">
            <th lcs-header-cell *lcsHeaderCellDef id="open-hours-column-header"></th>
            <td lcs-cell *lcsCellDef="let index = dataIndex" class="more-actions-btn"
              >@if (canEdit || canDelete) {
              <button
                type="button"
                aria-label="Schedule Hour Actions"
                matTooltip="More Actions"
                mat-icon-button
                [matMenuTriggerFor]="scheduleListItemMenu"
                [matMenuTriggerData]="{ $implicit: scheduleHourItems[index], index: index }"
                [disabled]="disabled"
                id="schedule-hour-list-option-menu-button-{{ index }}"
                >
                <mat-icon> more_horiz </mat-icon>
              </button>
            }
            <mat-menu #scheduleListItemMenu="matMenu">
              <input type="hidden" />
              @if (canEdit) {
                <button
                  mat-menu-item
                  type="button"
                  id="menu-edit"
                  (click)="onEditScheduleHourClick(index)"
                  >
                  Edit
                </button>
              }
              @if (canDelete) {
                <button
                  mat-menu-item
                  type="button"
                  id="menu-delete"
                  (click)="onDeleteClick(index)"
                  >
                  Delete
                </button>
              }
            </mat-menu></td
            >
          </ng-container>
        </table>
      </lcs-responsive-table>
    </div>
  </lcs-loading-overlay>
